<template>
  <main class="p20 bg-white main stock">
    <div class="mt20 mb20">
      <span class="title1">出库单</span>
      <!-- <router-link to='/prep/out/import' class="btn-scan ivu-btn ivu-btn-primary fr ml20">导入出库单</router-link> -->
    </div>
    <!-- <div class="tr mb10">
      <button class="ivu-btn ivu-btn-primary" @click="exportData">下载数据</button>
    </div> -->
    <div class="search-one" style="margin-top: 70px;">
      <div class="search-item">
        出库单号
        <Input class='ml10 mr20 w200' v-model="screen_data.out_bill_no" placeholder="请输入出库单号" />
        状态
        <Select v-model="screen_data.status" class='ml10 mr20 w200'>
          <Option v-for="(option, index) in statusList" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
      </div>
      <div class="search-item">
        <!--  客户编号
        <Input class='ml10 mr20 w200' v-model="screen_data.client_code" placeholder="请输入客户编号" /> -->
        创建时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
        <button class="ivu-btn ivu-btn-primary fr ml20" @click="search">搜索</button>
      </div>

    </div>
    <Table :loading="loading" class="mt20" border :columns="table_data.columns" :data="table_data.data">
      <template slot-scope="{ row, index }" slot="oprate">
        <a @click="getDetail(row.out_bill_no)" class="blue mr10">查看详情</a>
        <a v-if="row.status == 10" @click="cancel(row.out_bill_no)" class="blue mr10">取消</a>
        <!-- <a v-if="row.status == 30" @click="pay(row.out_bill_no)" class="blue mr10">付款</a> -->
        <!-- <a v-if="row.status == 30 || row.status==40 || row.status==50" @click="exportData(row.out_bill_no)" class="blue mr10">导出</a> -->
        <a v-if="row.status == 10" @click="uploadUrl(row.out_bill_no)" class="blue mr10">上传Label</a>
        <!-- <a v-if="row.status > 20" @click="printTicket(row.out_bill_no,index)" class="blue">打印发票</a> -->
      </template>
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>

    <Modal title="查看详情" v-model="show_detail" width="1200">
      <Table class="mt20" border :columns="detail_columns" :data="detail_list">
      </Table>
      <Table class="mt20" border :columns="package_columns" :data="package_list">
      </Table>
      <div slot="footer"></div>
    </Modal>

  </main>

</template>

<script>
  import Paging from '@/components/common/paging'

  export default {
    components: {
      Paging
    },
    data() {
      return {
        show_detail: false,
        detailInfo: {},
        statusList: [{
          value: '',
          label: '全部'
        }, {
          value: 10,
          label: '待上传'
        }, {
          value: 20,
          label: '待打印'
        }, {
          value: 30,
          label: '待打包'
        }, {
          value: 40,
          label: '待出库'
        }, {
          value: '-10',
          label: '已取消'
        }],
        detail_columns: [{
          title: '入库单号',
          key: 'in_bill_no',
          width: 200,
          fixed: 'left',
          tooltip: true,
        },{
          title: '快递单号',
          key: 'waybill',
          width: 200,
          tooltip: true,
        }, {
          title: 'SKU数',
          key: 'sku_count',
          width: 100,
          tooltip: true,
        }, {
          title: '商品数',
          key: 'product_count',
          tooltip: true,
          width: 100
        }, {
          title: '入库重量(LB)',
          key: 'weight',
          width: 100,
        }, {
          title: '长(INCH)',
          key: 'length',
          width: 100,
        }, {
          title: '宽(INCH)',
          key: 'width',
          width: 100,
        }, {
          title: '高(INCH)',
          key: 'height',
          width: 100,
        }, {
          title: '内含物',
          key: 'sku_details',
          tooltip: true,
          width: 200,
        }, {
          title: '入库时间',
          key: 'create_date',
          tooltip: true,
          width: 200,
        }],
        detail_list: [],
        package_list: [],
        package_columns: [{
          title: '包裹序号',
          width: 100,
          key: 'sequence'
        }, {
          title: '包裹号',
          key: 'package_no',
          width: 200,
          tooltip: true,
        }, {
          title: 'SKU种类',
          key: 'sku_count',
          tooltip: true,
          width: 100
        }, {
          title: '商品数量',
          key: 'product_count',
          width: 100,
        }, {
          title: '重量(LB)',
          key: 'weight',
          width: 100,
        }, {
          title: '长(INCH)',
          key: 'length',
          width: 100,
        }, {
          title: '宽(INCH)',
          key: 'width',
          width: 100,
        }, {
          title: '高(INCH)',
          key: 'height',
          width: 100,
        }, {
          title: '内含物',
          key: 'sku_detail',
          tooltip: true,
        }],
        print_package: {
          sku_list: [],
          sku_in_bill_list: []
        },
        table_data: { //列表数据
          columns: [],
          data: []
        },
        category: [],
        website: [],
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          warehouse_id: '',
          pageNum: 1,
          pageSize: 10,
          biz_type: 0
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
      }
    },
    methods: {
      getDetail(out_bill_no) {
        this.$axios.get("/WarehouseOut/bill/in_bill?out_bill_no=" + out_bill_no).then(res => {
          if (res.success && res.data) {
            this.detail_list = res.data
          } else {
            this.detail_list = []
          }
        })
        //包裹内含物
        this.$axios.get("/WarehouseOut/bill/package/list/skus?out_bill_no=" + out_bill_no).then(res => {
          if (res.success && res.data) {
            this.package_list = res.data
          } else {
            this.package_list = []
          }
        })
        this.show_detail = true;
      },
      init() {
        this.table_data.columns = this.setColumns();
        this.print_package.hole_package_list_columns = this.setPrintColumns();
        this.print_package.package_list_columns = this.setPrintColumns();
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      uploadUrl(out_bill_no) { //上传快递单跳转
        this.$router.push({
          path: '/zhongzhuanbuhuo/out/upload?out_bill_no=' + out_bill_no
        })
      },
      // 付款
      pay(out_bill_no) {
        const that = this;
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要支付单号为' + out_bill_no + '的出库单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            that.$axios.post("/ClientBill/fee/pay/outbill?out_bill_no=" + out_bill_no).then(res => {
              if (res.success) {
                that.$Message.success('支付成功');
                that.getList()
              }
            })
          },
          onCancel: () => {

          }
        });
      },
      //取消出库单
      cancel(out_bill_no) {
        const that = this;
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要取消单号为' + out_bill_no + '的出库单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            that.$axios.put("/WarehouseOut/bill/cancel?out_bill_no=" + out_bill_no).then(res => {
              if (res.success) {
                that.$Message.success('取消成功');
                that.getList()
              } else {
                that.$Message.error(res.msg);
              }
            })
          },
          onCancel: () => {

          }
        });

      },
      //打印发票
      printTicket(out_bill_no, index) {
        let d = { ...this.table_data.data[index]
        }
        this.$axios.get("/ClientBill/fee/outbill/detail?out_bill_no=" + out_bill_no, {
          headers: {
            noShowError: true
          }
        }).then(res => {
          let fee_list = res || []
          let user_info = JSON.parse(localStorage.getItem('user_info'))
          let obj = {
            out_bill_no: out_bill_no,
            date: d.create_date.substring(0, 10),
            client_name_code: d.client_code + ' ' + (d.user_name || ''),
            user_name: user_info.name,
            email: user_info.email,
            contact_phone: user_info.contact_phone,
            fee_list: fee_list,
            total_fee: d.total_fee || 0
          }
          localStorage.setItem('print_data', JSON.stringify(obj))

          let routeUrl = this.$router.resolve({
            path: "/PrintPage",
          });
          window.open(routeUrl.href, '_blank');
        })
      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/WarehouseOut/bill/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      exportData(out_bill_no) {
        this.$axios.get("/WarehouseOut/bill/detail/export/excel", {
          params: {
            out_bill_no: out_bill_no
          }
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '出库单号',
          key: 'out_bill_no',
          tooltip: true,
          width: 170,
          fixed: 'left'
        }, {
          title: '子账户编号',
          key: 'client_code',
          tooltip: true,
          minWidth: 120,
        }, {
          title: '姓名',
          key: 'client_name',
          tooltip: true,
          minWidth: 120,
        }, {
          title: 'SKU数',
          key: 'sku_count',
          tooltip: true,
          minWidth: 100,
        }, {
          title: '商品数',
          key: 'product_count',
          minWidth: 100,
          tooltip: true
        }, {
          title: '内含物',
          key: 'sku_details',
          width: 200,
          tooltip: true,
        }, {
          title: '状态',
          key: 'salePrice',
          minWidth: 80,
          render: (h, params) => {
            let status = params.row.status;
            let color = '';
            let txt = '';
            if (status == 10) { //待上传
              color = '#D9001B'
              txt = '待上传'
            } else if (status == 20) { // 待打印
              color = '#4acd40'
              txt = '待打印'
            } else if (status == 30) { //待打包
              color = '#FFB800'
              txt = '待打包'
            } else if (status == 40) { //待出库
              color = '#169BD5'
              txt = '待出库'
            } else if (status == 50) { //已出库
              color = '#00B212'
              txt = '已出库'
            } else if (status == '-10') { //已取消
              color = '#333'
              txt = '已取消'
            }
            return h('span', {
              style: {
                color: color
              },
            }, txt)
          }
        }, {
          title: 'PDF Label',
          key: 'amazon_pdf',
          minWidth: 100,
          render: (h, params) => {
            let color = '#333';
            let txt = '';
            if (params.row.amazon_pdf) {
              color = '#D9001B'
              txt = '查看'
            }
            return h('a', {
              style: {
                color: color
              },
              attrs: {
                href: params.row.amazon_pdf,
                target: '_blank'
              }
            }, txt)
          }
        }, {
          title: '更新时间',
          key: 'update_date',
          minWidth: 180,
        }, {
          title: '创建时间',
          key: 'create_date',
          minWidth: 180,
        }, {
          title: '操作',
          minWidth: 340,
          fixed: 'right',
          slot: 'oprate'
        }];
        return arr;
      },
      setPrintColumns() {
        let arr = [];
        arr = [{
          title: 'SKU',
          key: 'sku',
          tooltip: true,
          minWidth: 150,
        }, {
          title: '新SKU',
          key: 'new_sku',
          tooltip: true,
          minWidth: 150,
        }, {
          title: '所在包裹',
          key: 'in_bill_no',
          tooltip: true,
          minWidth: 150,
        }, {
          title: '数量',
          key: 'out_count',
          tooltip: true,
          minWidth: 100,
        }, {
          title: '所在货架',
          key: 'shelf_code',
          tooltip: true,
          minWidth: 150,
        }];
        return arr;
      }
    },
    created() {
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id')
      this.screen_data.client_code = localStorage.getItem('client_code') || ''
      if (this.screen_data.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
      this.init();
    }
  }
</script>

<style scoped>
  .stock .w200 {
    width: 200px !important;
  }

  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 40px;
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/zhongzhuanbuhuo/out/list.vue